import { Injectable, Injector, NgZone, inject } from '@angular/core';
import { ConnectionStatus, Network } from '@capacitor/network';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

// Types
import { PageNgOnInitCallBack } from '../../../shared/types/common';

// Services
import { LoggerService } from '../logger/logger.service';
import { OfflineService } from '../offline/offline.service';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private logger = inject(LoggerService);
  private zone = inject(NgZone);
  private platform = inject(Platform);
  private injector = inject(Injector);

  public connected: boolean;
  public blockedApp: boolean;

  public previousUrl: string;
  public currentUrl: string;

  public appStarted(): void {
    this.blockedApp = false;

    void Network.getStatus().then(({ connected }: ConnectionStatus) => {
      this.zone.run(() => {
        this.logger.consoleLog('NetworkService', 'getStatus', { connected });
        this.connected = connected;
      });
    });

    void Network.addListener('networkStatusChange', ({ connected }: ConnectionStatus) => {
      this.zone.run(() => {
        this.logger.consoleLog('NetworkService', 'networkStatusChange', { connected });
        this.connected = connected;

        if (connected) {
          this.blockedApp = false;
        }
      });
    });
  }

  public pageNgOnInit(
    from: string,
    callBack?: PageNgOnInitCallBack,
    notConnectedCallback?: PageNgOnInitCallBack,
  ): void {
    setTimeout(() => {
      void Network.addListener('networkStatusChange', ({ connected }) => {
        this.zone.run(() => {
          if (connected && this.connected !== connected) {
            const offline = this.injector.get(OfflineService);
            offline.isAlreadyGettingOfflineFile = false;
          }

          this.connected = connected;
          this.logger.consoleLog(from, 'networkStatusChange', { connected });

          if (connected) {
            this.blockedApp = false;
            callBack?.();
          } else {
            notConnectedCallback?.();
          }
        });
      });

      callBack();
    }, 2000);
  }

  public removeListeners(from: string): void {
    this.logger.consoleLog(from, 'removeListeners');
    void Network.removeAllListeners();
  }

  public getCurrentInternetState(): Promise<ConnectionStatus> {
    return Network.getStatus();
  }

  public allowNavigation(): Subscription | undefined {
    this.logger.consoleLog('NetworkService', 'allowNavigation', { currentUrl: this.currentUrl });

    if (this.currentUrl?.includes('splash') || this.currentUrl?.includes('home')) {
      return this.platform.backButton.subscribeWithPriority(10, () => {});
    }

    return undefined;
  }
}
